import React from "react";
import { Box, Typography } from "@material-ui/core";

const Terms = () => {
  return (
    <Box color="text.disabled">
      <Box mt={2} mb={1}>
        <Typography variant="caption">
          SEGURO OBLIGATORIO AUTOMOTOR CONFORME DECRETO Nº 1716/08
          (Reglamentario de la Ley Nacional de Tránsito y Seguridad Vial N°
          26.363).
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="caption">
          NOTA: La posesión de este comprobante obligatorio será prueba
          suficiente de la vigencia del seguro obligatorio de automotores
          exigido por el Artículo 68 de la Ley N° 24.449. Conforme el Artículo
          2° de la Disposición N° 70/2009 de la AGENCIA NACIONAL DE SEGURIDAD
          VIAL, la falta de portación del recibo de pago de la prima del seguro
          obligatorio por parte del conductor del vehículo, no podrá ser aducida
          por la Autoridad de Constatación para determinar el incumplimiento de
          los requisitos para la circulación.
        </Typography>
      </Box>
    </Box>
  );
};

export default Terms;
